export enum ActiveIntegration {
  JIRA,
  AZURE,
  ASANA,
  MONDAY,
  GITHUB,
  SLACK
}

export interface IntegrationCard {
  id: ActiveIntegration;
  name: string;
  description: string;
  features: string[];
  logo: string;
}


export const integrationData: IntegrationCard[] = [
  {
    id: ActiveIntegration.JIRA,
    name: "Jira",
    description: "Import projects, epics, and issues from Atlassian Jira",
    features: ["Issues & Epics", "Sprint Data", "Workflows"],
    logo: `https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/jiralogo.png`,
  },
  {
    id: ActiveIntegration.ASANA,
    name: "Asana",
    description: "Sync tasks, projects, and team collaboration from Asana",
    features: ["Tasks & Projects", "Timelines", "Dependencies"],
    logo: `https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/asana.png`,
  },
  {
    id: ActiveIntegration.AZURE,
    name: "Azure DevOps",
    description: "Connect with Azure DevOps for complete project lifecycle",
    features: ["Work Items", "Repositories", "Test Plans"],
    logo: `https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/devopsAsure.png`,
  },
  {
    id: ActiveIntegration.MONDAY,
    name: "Monday.com",
    description: "Import boards, items, and workflow data from Monday",
    features: ["Workflows", "Automations", "Time Tracking"],
    logo: `https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/mondaylogo.png`,
  },
  {
    id: ActiveIntegration.GITHUB,
    name: "GitHub",
    description: "Integrate repositories, issues, and project boards",
    features: ["Repositories", "Issues & PRs", "Project Boards"],
    logo: `https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/github_integration.png`,
  },
  {
    id: ActiveIntegration.SLACK,
    name: "Slack",
    description: "Connect Slack for conversations and notifications",
    features: ["Users", "Channels", "OAuth Connect", "Notifications"],
    logo: `https://cadence-fe-bucket.s3.us-east-2.amazonaws.com/images/slack-seeklogo-1.png`,
  }
];

export const getIntegrationType = (integration: ActiveIntegration): string => {
    switch (integration) {
      case ActiveIntegration.JIRA:
        return 'jira';
      case ActiveIntegration.ASANA:
        return 'asana';
      case ActiveIntegration.AZURE:
        return 'azure';
      case ActiveIntegration.MONDAY:
        return 'monday';
      case ActiveIntegration.GITHUB:
        return 'github';
      case ActiveIntegration.SLACK:
        return 'slack';
      default:
        return '';
    }
  };
